import { render, staticRenderFns } from "./ProjectsByGallery.vue?vue&type=template&id=042e2b82&lang=pug&"
import script from "./ProjectsByGallery.vue?vue&type=script&lang=js&"
export * from "./ProjectsByGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsByGallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports